<template>
  <!-- 广告图片弹窗 -->
  <GtcModal
    class="advertising-modal-pic"
    v-model:open="open"
    width="451px"
    :closable="false"
    :footer="null"
  >
    <div class="w-full h-[584px]">
      <img class="w-full h-full" :src="curAdvertising?.pic" alt="" />
      <SvgIcon
        name="common-close_modal"
        size="24"
        class="absolute bottom-[-44px] right-[50%] translate-x-[50%] cursor-pointer"
        @click="closeModal"
      />
    </div>
  </GtcModal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useAdvertisingStore } from '@/store/advertising'
import { storeToRefs } from 'pinia'
import { GtcModal } from '@/components'
import { SvgIcon } from '@/components'
const { curAdvertising, advertising } = storeToRefs(useAdvertisingStore())

const open = ref(false)
const emit = defineEmits<{
  (e: 'readAdvertising'): void
}>()

const closeModal = () => {
  open.value = false
}

watch(open, async (newVal) => {
  if (!newVal) {
    await emit('readAdvertising')
    advertising.value.shift()
  }
})
defineExpose({
  open,
})
</script>

<style lang="less" scoped></style>
